import * as pages from "pages";
import Page from "pages/Page";
import _ from "lodash";
import { BrowserRouter, Routes } from "react-router-dom";
import { Suspense, useEffect, useState } from "react";
import { useRightsContext } from "api/rights/RightsProvider";
import { useUserContext } from "api/user/UserProvider";
import { SCOPES } from "constants/constants";
import { pathSegmentsHelper } from "utils/helper";
import BrandedFullPageLoader from "core/loader/BrandedFullPageLoader";

const Router = () => {
  const { location } = document;
  const { userScope, userSetScope, userRoleList, userScopeList } =
    useUserContext();
  const { loadingRights } = useRightsContext();
  const [currentScope, setCurrentScope] = useState(null);
  const [loading, setLoading] = useState(true);
  const tabs = _.uniq([SCOPES.PERSO, SCOPES.MACRO, ...userScopeList]);

  const pathSegements = pathSegmentsHelper({ pathname: location?.pathname });
  const isRestrictedAccess = pathSegements?.at(-1) === "restricted-access";
  const restrictedAccessScope = pathSegements[0];

  let routes = Object.keys(pages).reduce((pagesRoutes, key) => {
    const scopeRoutes = tabs.map((elm) => {
      return pages[key].routes({
        userScope: elm,
        roles: userRoleList,
        loading: loadingRights,
        setLoading,
        ...(isRestrictedAccess
          ? {
              path: location?.pathname,
              urlWithoutScope: pathSegements.slice(1, -1).join("/"),
              restrictedAccessScope,
            }
          : {}),
      });
    });

    return pagesRoutes.concat(scopeRoutes);
  }, []);

  useEffect(() => {
    if (
      !["/login", "/logout"].includes(location.pathname) &&
      !_.startsWith(location.pathname, "/balancesheet/mission/slug") &&
      !_.startsWith(location.pathname, "/davidson-evaluation/mission") &&
      !_.startsWith(location.pathname, "/balancesheet/annual/slug") &&
      !_.startsWith(location.pathname, "/davidson-evaluation/davidson/consultant")
    ) {
      setLoading(currentScope === userScope);
      if (!userScope) {
        const [scope] = location.pathname
          .split("/")
          .filter((e) => e && e.length > 0);
        userSetScope(scope);
      }
      if (currentScope !== userScope) {
        setCurrentScope(userScope);
      }
      setLoading(currentScope === userScope);
    } else {
      setLoading(false);
    }
  }, [userScope]);

  return !loading ? (
    <Suspense fallback={<BrandedFullPageLoader />}>
      <BrowserRouter>
        <Page>
          <Routes>{routes}</Routes>
        </Page>
      </BrowserRouter>
    </Suspense>
  ) : null;
};

export default Router;
